import LockTableCellRenderer from "./LockTableCellRenderer";

export default class RunnerCellRenderer extends LockTableCellRenderer {
    generateContent(cell) {
        cell.getCellEl().innerHTML = '<div class="runnerCellStateImg"><div class="runnerCellArrow"></div></div>';
    }

    getCellClassName(cell) {
        return [
            this.getBackgroundClass(cell),
            this.getStateImgClass(cell),
            this.getArrowClass(cell)
        ].join(" ");
    }

    getBackgroundClass(cell) {
        if (this.isStateChanging(cell))
            return "runnerCellStateChanging";

        if (cell.getValue().runnerOver)
            return "runnerCellLocked";

        if (cell.getRow().isViewerTodayCell(cell))
            return "runnerCellToday";

        if (cell.getValue().working)
            return "runnerCellWorking";
        else
            return "runnerCellNonworking";
    }

    getStateImgClass(cell) {
        if (this.isStateChanging(cell)) {
            if (cell.getValue().runnerOver)
                return "unlockingImg";
            else if (this.isNewLastLocked(cell))
                return "lastLockingImg";
            else
                return "lockingImg";
        }
        else if (this.isHighlighted(cell) || this.isOldLastLocked(cell)) {
            return "lastLockedImg"
        }

        return "";
    }

    getArrowClass(cell) {
        if (this.isHighlighted(cell)) {
            if (this.isNewLastLocked(cell) || this.isOldLastLocked(cell)) {
                if (!this.isStateChanging(cell))
                    return "lockArrowHoverBg";
                else if (cell.getValue().working)
                    return "hoverArrowWorkingBg";
                else
                    return "hoverArrowDayoffBg";
            }
        }
        else if (this.isOldLastLocked(cell)) {
            if (cell.getValue().working)
                return "lockArrowWorkingBg";
            else
                return "lockArrowDayoffBg";
        }

        return "";
    }

    isStateChanging(cell) {
        if (this.isHighlighted(cell)) {
            let newLastLockDate = this.getRunnerController(cell).getNewLastLockDate();
            if (newLastLockDate != null) {
                let isCurrentlyUnlocked = newLastLockDate < cell.getValue().date;
                return isCurrentlyUnlocked != !cell.getValue().runnerOver;
            }
        }
    }

    getLastCellRightBorderClassName() {
        return "lockTableLightRightBorder";
    }

    getRunnerController(cell) {
        return cell.getRow().getTable().getRunnerController();
    }

    isHighlighted(cell) {
        return this.isHovered(cell) || this.getRunnerController(cell).isSelected(cell);
    }

    isNewLastLocked(cell) {
        return this.getRunnerController(cell).isNewLastLocked(cell);
    }

    isOldLastLocked(cell) {
        let lastLockedDate = this.getRunnerController(cell).getLastLockedDate();
        if (lastLockedDate != null)
            return lastLockedDate.getTime() == cell.getValue().date.getTime();
        else
            return false;
    }
}




// WEBPACK FOOTER //
// ./web/js/locktable/renderers/RunnerCellRenderer.js